import { AlertCircle } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from './alert'
import { AlertVariantsProps } from './types'
import { PropsWithChildren } from 'react'

export default function Component({
  title,
  description,
  show,
  children,
  className,
}: PropsWithChildren<Partial<AlertVariantsProps & { className?: string }>>) {
  if (!show) return null
  return (
    <Alert variant="destructive" className={className}>
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>{title || ''}</AlertTitle>
      <AlertDescription>{description || ''}</AlertDescription>
      {children}
    </Alert>
  )
}
